var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("SeaExport.TradeDetail"),
            width: "960px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "grid-view" }, [
            _c("div", { staticClass: "main-content" }, [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.ContainerSize")) +
                      "：" +
                      _vm._s(
                        _vm.containerInfo.eqSize + _vm.containerInfo.eqType
                      )
                  )
                ]),
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.ContainerNo")) +
                      "：" +
                      _vm._s(_vm.containerInfo.containerNo)
                  )
                ]),
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.SealNo")) +
                      "：" +
                      _vm._s(_vm.containerInfo.sealNo)
                  )
                ])
              ]),
              _c(
                "div",
                {
                  staticClass: "triggers",
                  staticStyle: { "margin-top": "10px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "1" },
                      on: { click: _vm.chooseGoodsBtnClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ChooseGoods")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", no: "2" },
                      on: { click: _vm.removeOrderBtnHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTheGoods")))]
                  ),
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { "margin-left": "30px" },
                      on: { change: _vm.toQuery },
                      model: {
                        value: _vm.selectOrderWindow.goodsMode,
                        callback: function($$v) {
                          _vm.$set(_vm.selectOrderWindow, "goodsMode", $$v)
                        },
                        expression: "selectOrderWindow.goodsMode"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            label: _vm.SystemConstants.FCL_TYPE.code,
                            disabled:
                              _vm.lcl.rowData.length > 0 ||
                              _vm.console.rowData.length > 0
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.FclOrderType")))]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            label: _vm.SystemConstants.LCL_TYPE.code,
                            disabled:
                              _vm.fcl.rowData.length > 0 ||
                              _vm.console.rowData.length > 0
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.LclOrderType")))]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            label: _vm.SystemConstants.CONSOLE_TYPE.code,
                            disabled:
                              _vm.fcl.rowData.length > 0 ||
                              _vm.lcl.rowData.length > 0
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ConsoleOrderType")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.selectOrderWindow.goodsMode ===
                            _vm.SystemConstants.LCL_TYPE.code,
                          expression:
                            "selectOrderWindow.goodsMode === SystemConstants.LCL_TYPE.code"
                        }
                      ],
                      staticClass: "calculation",
                      staticStyle: { float: "right" }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.totalLabel.TotalPacking) +
                            " " +
                            _vm._s(_vm.totalDesc.estimatedTotalPackings) +
                            " / " +
                            _vm._s(_vm.totalDesc.totalPackings)
                        )
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.totalLabel.TotalCubage) +
                            " " +
                            _vm._s(_vm.totalDesc.estimatedTotalCubages) +
                            " / " +
                            _vm._s(_vm.totalDesc.totalCubages)
                        )
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.totalLabel.TotalWeight2) +
                            " " +
                            _vm._s(_vm.totalDesc.estimatedTotalWeight) +
                            " / " +
                            _vm._s(_vm.totalDesc.totalWeight)
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.selectOrderWindow.goodsMode ===
                          _vm.SystemConstants.FCL_TYPE.code,
                        expression:
                          "selectOrderWindow.goodsMode === SystemConstants.FCL_TYPE.code"
                      }
                    ],
                    staticStyle: {
                      width: "100%",
                      height: "200px",
                      "margin-top": "5px"
                    },
                    attrs: {
                      "config-module": "130147",
                      "grid-options": _vm.fcl.gridOptions,
                      "column-defs": _vm.fcl.columnDefs,
                      "row-data": _vm.fcl.rowData
                    },
                    on: { gridReady: _vm.onFclGridReady }
                  }),
                  _c("cargo-ag-grid", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.selectOrderWindow.goodsMode ===
                          _vm.SystemConstants.LCL_TYPE.code,
                        expression:
                          "selectOrderWindow.goodsMode === SystemConstants.LCL_TYPE.code"
                      }
                    ],
                    staticStyle: {
                      width: "100%",
                      height: "200px",
                      "margin-top": "5px"
                    },
                    attrs: {
                      "config-module": "130131",
                      "grid-options": _vm.lcl.gridOptions,
                      "column-defs": _vm.lcl.columnDefs,
                      "row-data": _vm.lcl.rowData
                    },
                    on: { gridReady: _vm.onLclGridReady }
                  }),
                  _c("cargo-ag-grid", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.selectOrderWindow.goodsMode ===
                          _vm.SystemConstants.CONSOLE_TYPE.code,
                        expression:
                          "selectOrderWindow.goodsMode === SystemConstants.CONSOLE_TYPE.code"
                      }
                    ],
                    staticStyle: {
                      width: "100%",
                      height: "200px",
                      "margin-top": "5px"
                    },
                    attrs: {
                      "config-module": "130148",
                      "grid-options": _vm.console.gridOptions,
                      "column-defs": _vm.console.columnDefs,
                      "row-data": _vm.console.rowData
                    },
                    on: { gridReady: _vm.onConsoleGridReady }
                  })
                ],
                1
              )
            ])
          ]),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "3" },
                  on: { click: _vm.saveHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "4" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("trade-detail-select-order-window", {
        attrs: {
          visible: _vm.selectOrderWindow.visible,
          "goods-mode": _vm.selectOrderWindow.goodsMode,
          "cargo-doc": _vm.cargoDoc,
          "container-info": _vm.containerInfo
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectOrderWindow, "visible", $event)
          },
          reloadTable: _vm.reloadTable
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }